import { FC } from 'react'
import FirstLoginFlow from './index'
import { useLocation, Redirect } from 'react-router-dom'
import { firstLoginFlowRoutes } from './firstLoginFlowRoutes'
import { FIRST_LOGIN_FLOW_PATHS } from './FirstLoginFlowConstants'
import { isNil } from 'lodash'
import { RootStateOrAny, useSelector } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import routes from 'app/RootRoutes'
import Loading from 'egret/components/EgretLoadable/Loading'

interface Props {
  routes: typeof routes
  ref: React.MutableRefObject<undefined>
}

export const FirstLoginFlowNavLayer: FC<Props> = ({ routes, ref, children }) => {
  const location = useLocation()
  const isFirstLoginFlowRoute = !isNil(firstLoginFlowRoutes.find(r => r.path === location.pathname))
  const hasState = !isNil(location.state)
  const isMainFirstLoginFlowRoute = location.pathname === FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW
  const user = useSelector((state: RootStateOrAny) => state.user)
  const avaliableOrganizations = useSelector((state: RootStateOrAny) => state.avaliableOrganizations)
  const shouldDisplayFirstLoginFlow = !isNil(user.contact) && isNil(user.contact.whatAreYouLookingFor) && !isNil(avaliableOrganizations) && avaliableOrganizations?.length === 0
  const shouldDisplayMainApp = !isNil(user.contact?.whatAreYouLookingFor) || user.contact === null || avaliableOrganizations?.length > 0

  if (!shouldDisplayFirstLoginFlow && !shouldDisplayMainApp) {
    return <Loading />
  }

  if (shouldDisplayMainApp && !isFirstLoginFlowRoute) {
    return (children as JSX.Element)
  }

  if (shouldDisplayMainApp && isFirstLoginFlowRoute) {
    return <Redirect to={{ pathname: '/' }} />
  }

  if (!isFirstLoginFlowRoute) {
    return <Redirect to={{ pathname: FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW }} />
  }

  if (isMainFirstLoginFlowRoute) {
    return <FirstLoginFlow />
  }

  if (isFirstLoginFlowRoute && !hasState) {
    return <Redirect to={{ pathname: FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW }} />
  }

  if (isFirstLoginFlowRoute && hasState) {
    return (
      <div>
        {renderRoutes(routes, {
          scrollbarContentRef: ref
        })}
      </div>
    )
  }

  return <Loading />
}
